/**
 * External dependencies
 */
import { some } from 'lodash';

/**
 * Internal dependencies
 */
import getLocationWebsite from './get-location-website';
import getEdits from './get-edits';

export default (state, locationWebsiteId) => {
     
    const locationWebsite = getLocationWebsite(state, locationWebsiteId);
    const edits = getEdits(state, locationWebsiteId);

    if (!edits) {
        return false;
    }
   
    if (!locationWebsite && edits) {
        return true;
    }

    if (!locationWebsite) {
        return false;
    }

    const editsDirty = some(edits, (value, key) => {
        return locationWebsite[key] !== value;
    });

    return editsDirty;
};